export const generateArrayWithStrings = (text: string, count: number) => {
  const result = [];
  for (let i = 0; i < count; i++) {
    result.push(text);
  }
  return result;
};
